import { ThemeProvider as Provider } from 'styled-components';

import themeBrandV3 from '~/common/styled/theme-brand-v3';
import themeBrandV4 from '~/common/styled/theme-brand-v4';

const ThemeProvider = ({ children }) => {
  const themeBrand = {
    ...themeBrandV3,
    colors: {
      ...themeBrandV3.colors,
      ...themeBrandV4.colors
    }
  };

  return <Provider theme={themeBrand}>{children}</Provider>;
};

export default ThemeProvider;
